`use strict`;

import OwlCarousel from '../libs/owl-carousel';

class Banners {
    constructor() {
        this.initCarousel();
    }

    initCarousel() {
        let carousel = new OwlCarousel({
            lazyLoad: true,
            loop: true
        });
        carousel.init();
    }
}

new Banners();
